/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.20/esri/copyright.txt for details.
*/
import{g as e,a as o}from"./_commonjsHelpers.js";var t,r,s,a={exports:{}};t=a,r=a.exports,void 0!==(s=function(e,o){Object.defineProperty(o,"__esModule",{value:!0}),o.default={"Zoom Out":"Oddialiť","From %1 to %2":"Z %1 do %2","From %1":"Z %1","To %1":"Do %1"}}(0,r))&&(t.exports=s);var p=e(a.exports),d=Object.freeze(Object.assign(Object.create(null),a.exports,{default:p}));export{d as s};
